import { createTheme } from '@mui/material'
import { primaryTheme } from './theme1'
import { secondaryTheme } from './theme2'

export const theme = [
  createTheme(primaryTheme),
  createTheme(secondaryTheme)
]
